<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2><a href="#/account">{{$t('company.title_parent')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{$t('company.title')}}</h2>
        <div class="irinox-form">
          <div v-if="!role.includes('SERVICE')" class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="sector">{{$t('company.sector')}}</label>
                  <Dropdown id="sector" v-model="company.sector" :options="sectors" optionLabel="name" optionValue="code"  :disabled="company.verified"
                    :placeholder="$t('company.sector_ph')"
                    :class="{'p-invalid':v$.company.sector.$invalid && submitted}" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="type">{{$t('company.type')}}</label>
                  <Dropdown id="type" v-model="company.type" :options="types" optionLabel="name" optionValue="code"  :disabled="company.verified"
                    :placeholder="$t('company.type_ph')" />
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="country">{{$t('company.country')}}</label>
                  <Dropdown id="country" v-model="company.country" :options="countries" optionLabel="name" optionValue="code" 
                    :placeholder="$t('company.country_ph')"  :filter="true"
                    :class="{'p-invalid':v$.company.country.$invalid && submitted}" :disabled="company.verified"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="city">{{$t('company.city')}}</label>
                  <InputText id="city" type="text" v-model="company.city" :placeholder="$t('company.city_ph')" :disabled="company.verified"/>
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="address">{{$t('company.address')}}</label>
                  <InputText id="address" type="text" v-model="company.address" :placeholder="$t('company.address_ph')" :disabled="company.verified"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="district">{{$t('company.district')}}</label>
                  <InputText id="district" type="text" v-model="company.district" :placeholder="$t('company.district_ph')" :disabled="company.verified"
                    :class="{'p-invalid':v$.company.district.$invalid && submitted}"/>
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="postalCode">{{$t('company.postalCode')}}</label>
                  <InputText id="postalCode" type="text" v-model="company.postalCode" :placeholder="$t('company.postalCode_ph')" :disabled="company.verified"
                    :class="{'p-invalid':v$.company.postalCode.$invalid && submitted}" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="name">{{$t('company.name')}}</label>
                  <InputText id="name" type="text" v-model="company.name"  :disabled="company.verified"
                    :placeholder="$t('company.name_ph')"
                    :class="{'p-invalid':v$.company.name.$invalid && submitted}"/>
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="phone">{{$t('company.phone')}}</label>
                  <InputText id="phone" type="phone" v-model="company.phone" :placeholder="$t('company.phone_ph')"  :disabled="company.verified"
                  :class="{'p-invalid':v$.company.phone.$invalid && submitted}"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="taxCode">{{$t('company.taxCode')}}</label>
                  <InputText id="taxCode" type="text" v-model="company.taxCode"  :disabled="company.verified"
                    :placeholder="$t('company.taxCode_ph')"
                    :class="{'p-invalid':v$.company.taxCode.$invalid && submitted}"/>
              </div>
          </div>

          <div v-if="company.verified" class="p-mt-3 p-mb-1" style="font-style: italic;">
            {{ $t('company.verified') }}
          </div>
          
        </div>
		</div>
	</div>
  <div class="footer-toolbar">
    
    <Button :label="$t('company.save_button')" autofocus @click="save(!v$.$invalid)"  :disabled="company.verified"/>
  </div>

  <IrinoxDialogDark :visible="successDialog" mode="success" :message="$t('company.success_dialog')"
    :life="3000" @update:visible="successDialog = $event"></IrinoxDialogDark>

  <IrinoxDialogDark :visible="errorDialog" mode="error" :message="$t('company.error_dialog')"
    :life="3000" @update:visible="errorDialog = $event"></IrinoxDialogDark>

  <IrinoxDialogDark :visible="blockingErrorDialog" mode="error" :message="$t('company.error_dialog')"
    :life="0" @update:visible="blockingErrorDialog = $event"></IrinoxDialogDark>
  
</template>

<script>
import AccountService from '../../service/AccountService';
import CountryService from '../../service/CountryService';
import { required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        IrinoxDialogDark,
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
          company: {},
          countries: [],
          sectors: [{
            name: this.$t('company.sectors.dealer'),
            code: "dealer"
          },{
            name: this.$t('company.sectors.consultant'),
            code: "consultant"
          },{
            name: this.$t('company.sectors.gastronomy'),
            code: "gastronomy"
          },{
            name: this.$t('company.sectors.bakery'),
            code: "bakery"
          },{
            name: this.$t('company.sectors.pastry'),
            code: "pastry"
          },{
            name: this.$t('company.sectors.pastry_bakery'),
            code: "pastry_bakery"
          },{
            name: this.$t('company.sectors.icecream'),
            code: "icecream"
          },{
            name: this.$t('company.sectors.foodchain'),
            code: "foodchain"
          },{
            name: this.$t('company.sectors.catering'),
            code: "catering"
          },{
            name: this.$t('company.sectors.schoolcooking'),
            code: "schoolcooking"
          },{
            name: this.$t('company.sectors.foodindustry'),
            code: "foodindustry"
          },{
            name: this.$t('company.sectors.hotel'),
            code: "hotel"
          },{
            name: this.$t('company.sectors.largedistribution'),
            code: "largedistribution"
          },{
            name: this.$t('company.sectors.nonfoodsector'),
            code: "nonfoodsector"
          },{
            name: this.$t('company.sectors.assistance'),
            code: "assistance"
          },{
            name: this.$t('company.sectors.manufacturerepresentative'),
            code: "manufacturerepresentative"
          },{
            name: this.$t('company.sectors.other'),
            code: "other"
          }],
          types: [{
            name: this.$t('company.types.butchergastronomyshop'),
            code: "butchergastronomyshop"
          },{
            name: this.$t('company.types.freshpasta'),
            code: "freshpasta"
          },{
            name: this.$t('company.types.cateringbanqueting'),
            code: "cateringbanqueting"
          },{
            name: this.$t('company.types.agritourism'),
            code: "agritourism"
          },{
            name: this.$t('company.types.hotel'),
            code: "hotel"
          },{
            name: this.$t('company.types.foodchain'),
            code: "foodchain"
          },{
            name: this.$t('company.types.restaurant'),
            code: "restaurant"
          },{
            name: this.$t('company.types.foodindustry'),
            code: "foodindustry"
          },{
            name: this.$t('company.types.supermarket'),
            code: "supermarket"
          },{
            name: this.$t('company.types.fishshop'),
            code: "fishshop"
          },{
            name: this.$t('company.types.dairy'),
            code: "dairy"
          },{
            name: this.$t('company.types.transportfoodservice'),
            code: "transportfoodservice"
          },{
            name: this.$t('company.types.helthcare'),
            code: "helthcare"
          },{
            name: this.$t('company.types.schools'),
            code: "schools"
          },{
            name: this.$t('company.types.companyfoodservice'),
            code: "companyfoodservice"
          },{
            name: this.$t('company.types.cookingschools'),
            code: "cookingschools"
          },{
            name: this.$t('company.types.other'),
            code: "other"
          },],
          submitted: false,
          successDialog: false,
          errorDialog: false,
          blockingErrorDialog: false,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          role: 'userdata/role',
        }),
    },
    validations() {
        return {
            company: {
              name: {
                  required
              },
              taxCode: {
                  required,
                  valid: this.$functions.taxCodeCheck
              },
              sector: {
                  required
              },
              country: {
                  required
              },
              district: {
                required: requiredIf(function() {
                      return this.company.country==='IT'
                    })
              },
              city: {
                  required
              },
              postalCode: {
                required: requiredIf(function() {
                      return this.company.country==='DE'
                    })
              },
              phone: {
                  required
              },
            }
        }
    },
    created() {
      this.countryService = new CountryService();
      this.accountService = new AccountService();
    },
    mounted() {
        this.countryService.getCountries().then((countries) => {
            this.countries = countries;
        });
        this.getCompany();
    },
    methods: {
      getCompany() {
        this.accountService.getCompany(this.personaltoken)
          .then(company => {
            this.company = company;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.blockingErrorDialog = true;
          });
      },
      logoutDialogToggle() {
        this.logoutDialog = !this.logoutDialog;
      },
      logout() {
        this.logoutDialog = false;
        this.$store.commit('userdata/logout');
      },
      save(isFormValid) {
        this.submitted = true;

        if (!isFormValid) {
          return;
        }

        let updateData = {};
        updateData.name = this.company.name;
        updateData.sector = this.company.sector;
        updateData.type = this.company.type;
        updateData.country = this.company.country;
        updateData.city = this.company.city;
        updateData.address = this.company.address;
        updateData.district = this.company.district;
        updateData.postalCode = this.company.postalCode;
        updateData.phone = this.company.phone;
        updateData.taxCode = this.company.taxCode;

        this.accountService.putCompany(this.personaltoken, updateData)
          .then(() => {
            this.successDialog = true;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });
      }
    }
}
</script>

<style>

</style>